var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"lang-chip",style:(_vm.chipStyle),attrs:{"x-small":!_vm.isInner,"small":_vm.isInner,"color":_vm.isInner ? undefined : _vm.chipColor,"rounded":""}},[_vm._v(_vm._s(_vm.shortLabel))])}
var staticRenderFns = []

export { render, staticRenderFns }